import {
  CEOMessageSection,
  HowItWorksSection,
  FeaturesSection,
  LatestNewsSection,
  StartCryptoSection,
  WhyRoundPESection,
  SupportedNetworks
} from './Sections';

export const LandingScreen = () => {
  return (
    <>
      <StartCryptoSection />
      <SupportedNetworks />
      <HowItWorksSection />
      {/* <CEOMessageSection /> */}
      <FeaturesSection />
      <WhyRoundPESection />
      {/* <LatestNewsSection /> */}
    </>
  );
};
